import React from "react";
import { Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import * as footerService from "../../Services/footerServices";
import { ELinksURL } from "../../utils/enum/linksOnFooter";

export const ContentFooter = () => {
    const [contentState, setContentState] = React.useState<any>();
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const location = useLocation();

    const editorContentFromString = (contentValue: any) => {
        let result: any;
        const input = {
            blocks: JSON.parse(contentValue).blocks,
            entityMap: {},
        };
        try {
            result = {
                state: EditorState.createWithContent(convertFromRaw(input)),
            };
        } catch (e) {
            console.log(e);
        }
        return result;
    };

    React.useEffect(() => {
        //console.log("Fetching Footer data from ContentFooter.tsx component");
        footerService
            .getFooterData()
            .then((resp) => {
                if (resp && resp.links) {
                    let content;
                    if (location.pathname.endsWith(ELinksURL.FAQ))
                        content = editorContentFromString(
                            JSON.stringify(resp.links["FAQ"].state)
                        );
                    else if (
                        location.pathname.endsWith(ELinksURL.A_PROPOS_DE_NOUS)
                    )
                        content = editorContentFromString(
                            JSON.stringify(resp.links["A_propos_de_nous"].state)
                        );
                    else if (location.pathname.endsWith(ELinksURL.NOS_VALEURS))
                        content = editorContentFromString(
                            JSON.stringify(resp.links["Nos_valeurs"].state)
                        );
                    else if (
                        location.pathname.endsWith(ELinksURL.NOUS_CONTACTER)
                    )
                        content = editorContentFromString(
                            JSON.stringify(resp.links["Nous_contacter"].state)
                        );
                    else if (
                        location.pathname.endsWith(
                            ELinksURL.GARANTIE_DE_PROTECTION_DES_VOYAGEURS
                        )
                    )
                        content = editorContentFromString(
                            JSON.stringify(
                                resp.links[
                                    "Garantie_de_protection_des_voyageurs"
                                ].state
                            )
                        );
                    else if (location.pathname.endsWith(ELinksURL.CGU))
                        content = editorContentFromString(
                            JSON.stringify(
                                resp.links["Condition_générales_d_utilisation"]
                                    .state
                            )
                        );
                    else if (location.pathname.endsWith(ELinksURL.PDC))
                        content = editorContentFromString(
                            JSON.stringify(
                                resp.links["Politiques_de_confidentialités"]
                                    .state
                            )
                        );
                    setContentState(content);
                    // let upData = linksStringToData(resp.links);
                    // setLinks(upData);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }, [location.pathname]);
    return (
        <Stack direction="column" lineHeight="30px" marginTop="25px">
            <Editor
                readOnly
                toolbarHidden
                editorState={contentState?.state ?? EditorState.createEmpty()}
            />
        </Stack>
    );
};
